<template>
    <form @submit.prevent="login" class="login-form">
        <el-input v-model="user" placeholder="请输入用户名" />
        <el-input v-model="password" type="password" placeholder="请输入密码" />
        <VerificationCode ref="verificationCodeRef" class="input-field" />
        <el-button class="login-button" type="success" @click="login">登录</el-button>
    </form>
</template>

<script>
import VerificationCode from '@/components/VerificationCode.vue'

export default {
    data() {
        return {
            user: "",
            password: "",
        }
    },
    components: {
        VerificationCode,
    },
    methods: {
        async login() {
            console.log(this. user)
            const isValid = this.$refs.verificationCodeRef.validateCode();
            if (!isValid) {
                alert("验证码错误，请重新输入");
                return;
            }
            try {
                const response = await this.$axios.post("/api/login", {
                    user: this. user,
                    password: this.password
                });

                if (response.code === 0) {
                    // 登录成功
                    this.$emit('login-success', response.data);
                } else {
                    // 登录失败
                    this.$emit('login-error', response.msg || '登录失败');
                }
            } catch (error) {
                console.log(error)
                // console.error("An error occurred while trying to login", error.response.data);
                // this.$emit('login-error', error.response.data);
            }
        },

    }
};
</script>

<style scoped>
.login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 8px;
}

/* 输入框样式 */
.login-form input {
    width: 100%;
    /* 输入框宽度 */
    margin-bottom: 20px;
    /* 输入框底部间距 */
    padding: 10px;
    /* 输入框内部填充 */
    border-radius: 4px;
    /* 输入框圆角 */
    box-sizing: border-box;
    /* 边框盒模型 */
}

/* 验证码组件样式 */
.input-field {
    width: 100%;
    display: flex;
    margin-top: 5px;
    justify-content: space-between;
    /* 内部元素间距 */
    align-items: center;
    /* 垂直对齐 */
}


.el-input {
    margin: 5px;
}

.login-button{
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
}
/* 按钮鼠标悬停效果 */
.login-button:hover {
    background-color: #0056b3;
}
</style>